const MultiSelectOptionsContainerStyle = `
  grid-auto-flow: row;
  grid-column-gap: 17px;
  grid-row-gap: 17px;
  grid-template-columns: repeat(2, 1fr);
`;

export default MultiSelectOptionsContainerStyle;
